export default function LogsDownload() {
  return <h1 className="text-2xl">Logs download page</h1>;
}
